<template>
  <div>
    <div ref="editorBox"></div>
  </div>
</template>

<script>
  import wangEditor from "wangeditor";
  import { mapState } from "vuex";

  export default {
    props: {
      value: {
        type: String,
        default: "",
      },
    },
    computed: {
      ...mapState(["userInfo"]),
    },
    watch: {
      // 异步加载的公告内容到达后回填编辑器（避免组件先挂载、数据后到导致空白）
      value(newVal) {
        if (this.editor && newVal !== this.editor.txt.html()) {
          this.editor.txt.html(newVal || "");
        }
      },
    },
    mounted() {
      const editor = new wangEditor(this.$refs.editorBox);
      editor.config.height = 300;
      editor.config.onchange = (html) => {
        this.$emit("input", html);
      };

      // 图片上传走系统现有上传接口（key 鉴权）
      editor.config.uploadImgServer =
        process.env.VUE_APP_BASE_API + "/api/upload";
      editor.config.uploadFileName = "file";
      editor.config.uploadImgParams = {
        key: this.userInfo.Secret_key || "",
      };
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024;
      editor.config.uploadImgHooks = {
        customInsert: (insertImg, res) => {
          if (res.code == 200 && res.data && res.data.url) {
            insertImg(res.data.url);
          } else {
            this.$Message.error({
              background: true,
              content: res.msg || "图片上传失败",
            });
          }
        },
      };

      editor.create();
      if (this.value) {
        editor.txt.html(this.value);
      }
      this.editor = editor;
    },
    beforeDestroy() {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
  };
</script>

<style lang="less" scoped>
  /deep/ .w-e-text-container {
    background: #fff;
  }
</style>
